import React, { useState } from 'react';
import { StylishNewButton } from '../DesignSystems/New/StylishNewButton';
import { SharedIcon } from '../SharedIcon/SharedIcon';
import ActionsTable from './ActionsTable';
import EditOrgActionsModal from './EditOrgActionsModal';
import { ORGANIZATION } from '../IAP/ICSConstants';
import { GetOrgActionResponse } from './hooks/orgActionHooks';

const OrgActionsPage: React.FC = () => {
  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [selectedAction, setSelectedAction] =
    useState<GetOrgActionResponse | null>(null);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center pb-2">
        <div className="txt-md">Actions</div>
        <StylishNewButton
          className="button--primary"
          onClick={() => setShowAddDrawer(true)}
        >
          <SharedIcon iconName="add" classes="me-2" />
          Add Action
        </StylishNewButton>
      </div>

      <ActionsTable scope={ORGANIZATION} onEditAction={setSelectedAction} />

      {showAddDrawer && (
        <EditOrgActionsModal toggle={() => setShowAddDrawer(false)} />
      )}
      {selectedAction && (
        <EditOrgActionsModal
          selectedEntity={selectedAction}
          toggle={() => setSelectedAction(null)}
        />
      )}
    </div>
  );
};

export default OrgActionsPage;
